module.exports = __webpack_public_path__ + "img/SI5214246.91e58ea8.png";